import { render, staticRenderFns } from "./ResourceName.vue?vue&type=template&id=44cc8930"
import script from "./ResourceName.vue?vue&type=script&lang=js"
export * from "./ResourceName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports